import { render } from "./CustomerView.vue?vue&type=template&id=58ec7b9b&ts=true"
import script from "./CustomerView.vue?vue&type=script&lang=ts"
export * from "./CustomerView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__